import { render } from "./clients-filter.vue?vue&type=template&id=2e4e1d49"
import script from "./clients-filter.vue?vue&type=script&lang=js"
export * from "./clients-filter.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__